import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import { getCurrentLocale } from "@/utils/local-storage";

import {
  enTranslations,
  frTranslations,
  nlTranslations,
  esTranslations,
  deTranslations,
} from "./translations";
import { DEFAULT_LOCALE } from "./types";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: getCurrentLocale(),
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    resources: {
      en: enTranslations,
      fr: frTranslations,
      nl: nlTranslations,
      es: esTranslations,
      de: deTranslations,
    },
    ns: ["common"],
    defaultNS: "common",
  });

export default i18n;
